module.exports = __webpack_public_path__ + "media/images/icon_search-effd56b4c0ff03afa4be5a804ca29780.png";